module.exports = __webpack_public_path__ + "static/media/Trazado 9135@2x.b664d230.png";